import * as api from "../../api";
import { buildAlertWithLocalizedMessages } from "../";
import { jsError } from "../../common/utils";
/* export * from "./authentication"; */

export const deleteEmploymentCertificate = personId => {
  return dispatch => {
    dispatch({ type: "DELETE_EMPLOYMENT_CERTIFICATE_LOADING" });
    api
      .employmentCertificateDelete(personId)
      .then(resp => {
        dispatch(operationSucceeded(personId));
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "DeleteEmploymentCertificateErrorAlertTitle",
          "Virhe poistaessa työtodistusta",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const operationSucceeded = (id) => ({
  type: "DELETE_EMPLOYMENT_CERTIFICATE_SUCCEEDED",
  payload: { employmentCertificate: { personId: id, rowId: id } }
});

const operationFail = () => ({
  type: "DELETE_EMPLOYMENT_CERTIFICATE_FAIL"
});
